module.exports = __webpack_public_path__ + "media/images/new/see_favorites_in_search_laptop@2x-851c88459f211879ce10172466713374.png";